import { z } from 'zod'
import { emailAddress } from './email-address'

export const forgotPasswordSchema = z.object({
  email: emailAddress,
})

export type ForgotPasswordDto = z.infer<typeof forgotPasswordSchema>
